export const feedbackTranslations = {
  en: {
    pageTitle: 'Send Feedback',
    description: 'If you have spotted any unmarked hazards or unusual situations on the river or its banks, please let us know, and we will take action as soon as possible to verify the situation and intervene where necessary.',
    nameLabel: 'Name',
    nameError: 'Please enter your name',
    emailLabel: 'Email',
    emailRequired: 'Please enter an email address',
    emailInvalid: 'Invalid email format',
    messageLabel: 'Message',
    messageError: 'Please enter the message text',
    uploadButton: 'Upload images',
    privacyLabel1: 'I accept the ',
    privacyLabel2: ' of the app*',
    submitButton: 'Send feedback',
    successTitle: 'Thank you!',
    successMessage: 'Feedback sent successfully - Thank you for helping us improve the Po River navigation service.',
    serverErrorTitle: 'Server Error',
    serverErrorMessage: 'There was a problem on the server! Please restart the app and try again.',
    sendErrorTitle: 'Send Error',
    sendErrorMessage: 'There was a problem sending the message! Please restart the app and try again.'
  },
  it: {
    pageTitle: 'Invio segnalazioni',
    description: 'Se avete avvistato dei pericoli non segnalati o delle situazioni anomale sul fiume o sulle sue sponde segnalatecelo, ci attiveremo quanto prima per verificare la situazione e intervenire dove necessario.',
    nameLabel: 'Nome',
    nameError: 'Immettere il suo nome',
    emailLabel: 'Email',
    emailRequired: 'Immettere un indirizzo mail',
    emailInvalid: 'Formato email non valido',
    messageLabel: 'Messaggio',
    messageError: 'Immettere il testo del messaggio da inviare',
    uploadButton: 'Carica immagini',
    privacyLabel1: 'Accetto la ',
    privacyLabel2: 'dell\'app*',
    submitButton: 'Invia segnalazione',
    successTitle: 'Grazie!',
    successMessage: 'Segnalazione inviata correttamente - Grazie per aiutarci a migliorare il servizio ai naviganti del Po.',
    serverErrorTitle: 'Errore sul server',
    serverErrorMessage: 'C\'è stato un problema sul server! Per favore riavvia l\'app e riprova.',
    sendErrorTitle: 'Errore di invio',
    sendErrorMessage: 'C\'è stato un problema nell\'invio del messaggio! Per favore riavvia l\'app e riprova.'
  }
}; 